import { render, staticRenderFns } from "./SuccessRevision.vue?vue&type=template&id=da73ebfa&scoped=true"
import script from "./SuccessRevision.vue?vue&type=script&lang=js"
export * from "./SuccessRevision.vue?vue&type=script&lang=js"
import style0 from "./SuccessRevision.vue?vue&type=style&index=0&id=da73ebfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da73ebfa",
  null
  
)

export default component.exports